import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import OnboardingHeader from 'Views/Onboarding/Components/Header';
import LinearProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/LinearProgress';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import useProcessingProgress
  from 'Views/Onboarding/Pages/SubscriptionSetup/SubscriptionSetupContent/useProcessingProgress';

const styles = theme => ({
  root: {},
  rootHidden: {
    display: 'none',
  },
  content: {
    paddingTop: theme.spacing(12),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentTitle: {},
  linearProgress: {
    marginTop: theme.spacing(2),
    borderRadius: theme.radius.sm,
    transform: 'translateZ(0)', // <--- Corrects bizarre issue where the loaders border radius is removed by iOS / Safari
    width: '100%',
  },
});

const SubscriptionSetupProcessing = ({
  className,
  classes,
}) => {
  const progress = useProcessingProgress();

  useScrollTopOnMount();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {/* -------- Main Header -------- */}
      <OnboardingHeader
        title={'Payment'}
        centered
      />
      <div className={classes.content}>
        <Typography
          className={classes.contentTitle}
          variant={'h5'}
          weight={'bold'}
          color={'primary'}
          test={'subscription-setup-processing-payment'}
        >
          {'Processing Payment'}
        </Typography>
        <LinearProgress
          color={'primaryToAccentBlue'}
          variant="determinate"
          value={progress}
          classes={{
            root: classes.linearProgress,
          }}
        />
      </div>
    </Box>
  );
};

SubscriptionSetupProcessing.defaultProps = {
  className: '',
};

SubscriptionSetupProcessing.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SubscriptionSetupProcessing);
